import { createAction } from '@reduxjs/toolkit';
import { CustomerIntegrationSettings, ErrorObject } from 'types';

export const changeIntegrationLegalHold = createAction<boolean>(
  'INTEGRATION_SETTINGS/CHANGE_LEGAL_HOLD'
);

export const changeIntegrationRetentionPolicy = createAction<string>(
  'INTEGRATION_SETTINGS/CHANGE_RETENTION_POLICY'
);

export const changeIntegrationRetentionPeriod = createAction<string>(
  'INTEGRATION_SETTINGS/CHANGE_RETENTION_PERIOD'
);

export const changeIntegrationUseCases = createAction<string[]>(
  'INTEGRATION_SETTINGS/CHANGE_USE_CASES'
);

export const changeIntegrationTranslations = createAction<boolean>(
  'INTEGRATION_SETTINGS/CHANGE_TRANSLATIONS'
);

export const changeIntegrationPreventTranslations = createAction<boolean>(
  'INTEGRATION_SETTINGS/CHANGE_PREVENT_TRANSLATIONS'
);

export const changeIntegrationPreventLanguages = createAction<string>(
  'INTEGRATION_SETTINGS/CHANGE_PREVENT_LANGUAGES'
);

export const resetForm = createAction('INTEGRATION_SETTINGS/RESET_FORM');

type UpsertIntegrationSettingsPayload = Partial<CustomerIntegrationSettings>;

export const upsertIntegrationSettings = createAction<UpsertIntegrationSettingsPayload>(
  'INTEGRATION_SETTINGS/UPSERT_INTEGRATION_SETTINGS'
);
export const upsertIntegrationSettingsRequest = createAction(
  'INTEGRATION_SETTINGS/UPSERT_INTEGRATION_SETTINGS_REQUEST'
);
export const upsertIntegrationSettingsFailure = createAction<ErrorObject>(
  'INTEGRATION_SETTINGS/UPSERT_INTEGRATION_SETTINGS_FAILURE'
);
export const upsertIntegrationSettingSuccess = createAction<CustomerIntegrationSettings>(
  'INTEGRATION_SETTINGS/UPSERT_INTEGRATION_SETTINGS_SUCCESS'
);

export const fetchIntegrationSettings = createAction(
  'INTEGRATION_SETTINGS/FETCH_SINGLE_INTEGRATION_SETTINGS'
);
export const fetchIntegrationSettingsRequest = createAction(
  'INTEGRATION_SETTINGS/FETCH_SINGLE_INTEGRATION_SETTINGS_REQUEST'
);
export const fetchIntegrationSettingsFailure = createAction<ErrorObject>(
  'INTEGRATION_SETTINGS/FETCH_SINGLE_INTEGRATION_SETTINGS_FAILURE'
);
export const fetchIntegrationSettingsSuccess = createAction<CustomerIntegrationSettings>(
  'INTEGRATION_SETTINGS/FETCH_SINGLE_INTEGRATION_SETTINGS_SUCCESS'
);
